import { updateLinksAttributes } from '../utils.js';

export default function cardWidget7() {
  const widgetName = 'cardWidget7';
  const widgetOpts = cardWidget7Opts;
  const wrapContainerClass = 'cardWidget7-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: false,
    moreButton: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x] || {};

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>`);

      $cardItem.removeClass('void-link').removeAttr('target rel aria-disabled aria-label');

      if (URL) {
        $cardItem.attr('href', URL);
      } else {
        $cardItem.removeAttr('href');
      }

      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}
